import { jsonPost, formPost } from '../components/ajax';
import { API_REFERENCE } from '../utilities/constant_api';
import { numbersOnly, checkWidth, checkHeight } from '../utilities/utility';
import * as constantConfig from '../utilities/constant_config';

const mfaEnrollInvalidPhoneError = '.mfa-phone-invalid-error';
const mfaEnrollOtpTimer = 30;
const mfaEnrollSetupTypeSms = 'sms';
const mfaEnrollSetupTypeCall = 'call';
const mfaEnrollSendCodePass = 'PENDING_ACTIVATION';
const mfaEnrollSuccessCheck = 'ACTIVE';
const mfaAccSettingsSetupEle = '.mfa-setup-type-button';
const mfaAccSettingsSetupText = 'Set up';
const mfaAccSettingsClosestParentEle = '.mfa-setup-type';
const mfaAccSettingsSetupRow = '.mfa-setup-section';
const mfaAccSettingsSetupTypeSelected = '.mfa-setup-type-details';
const mfaAccSettingsVerifySection = '.mfa-setup-verify-details';
const mfaAccSettingsSetupCancelBtn = '.mfa-setup-cancel-btn';
const mfaAccSettingsPhoneNumber = '.mfa-setup-phone-number';
const mfaAccSettingsSendOtpButton = '.mfa-setup-send-code-btn';
const mfaAccSettingsPhoneSection = '.mfa-setup-label-phone-section';
const mfaAccSettingsOtpMsg = '.mfa-setup-otp-timer-msg';
const mfaAccSettingsOtpEle = '.mfa-setup-otp-timer';
const mfaAccSettingsOtpResendEle = '.mfa-setup-otp-resend';
const mfaAccSettingsOtpResendBtnEle = '.mfa-setup-resend-otp-btn';
const mfaAccSettingsVerifyBtnEle = '.mfa-setup-verify-btn';
const mfaAccSettingsVerifyInputEle = '.mfa-setup-verify-input';
const mfaAccSettingsContainer = '#mfa-setup-container';
const mfaAccSettingsRemoveAuthType = '#mfa-remove-auth-type';
const mfaAccSettingsRemoveForm = '#mfa-modal-pwd-form';
const mfaAccSettingsRemovePwdEle = '#mfa-modal-input-pwd';
const mfaAccSettingsRemoveCancelBtn = '#mfa-modal-btn-cancel';
const mfaAccSettingsRemoveCloseBtn = '#mfa-modal-close-btn';
const mfaAccSettingsRemoveConfirmBtn = 'mfa-modal-confirm-pwd-btn';
const mfaAccSettingsSmsContainer = '#mfa-setup-sms';
const mfaAccSettingsVoiceContainer = '#mfa-setup-voice';
const mfaAccSettingsSetupSection = '.mfa-setup-edit';
const mfaAccSettingsRemoveSmsSetup = 'Text Message';
const mfaAccSettingsRemoveVoiceSetup = 'Voice Call';
const mfaAccSettingsEnrollType = '#mfa-modal-enroll-type';
const mfaAccSettingsSetupSuccess = '#mfa-setup-success-alert';
const mfaAccSettingsFailureSetup = '#mfa-setup-failure-alert';
const mfaAccSettingsAlerts = '.mfa-setup-alert';
const mfaAccSettingsErrorAlerts = '.error-msg-text';
const mfaAccSettingsErrorInputBox = 'error-msg-textbox';
const mfaAccSettingsErrorOtpMismatch = '.mfa-setup-otp-mismatch';
let mfaAccSettingsRemoveFactorAjaxReq = true;
let mfaAccSettingsSendOtpAjaxReq = true;
let mfaAccSettingsReSendOtpAjaxReq = true;
let mfaAccSettingsVerifyOtpAjaxReq = true;

const mfaOktaAccSettings = {
  checkHeight() {
    return constantConfig.CBOX_OPTIONS.maxHeightLg;
  },
  formatSmsPhoneNumber(phoneNumberString) {
    let phone = phoneNumberString.replace(/\D/g, '');
    let match = phone.match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      phone = ''
        .concat(match[1])
        .concat(match[2] ? '.' : '')
        .concat(match[2])
        .concat(match[3] ? '.' : '')
        .concat(match[3]);
    }
    return phone;
  },

  onInputPhoneNumber(e) {
    const numberFormat = numbersOnly(e);
    if (numberFormat) {
      $(e.target).removeClass('error-msg-textbox');
      $(e.target)
        .parents(mfaAccSettingsPhoneSection)
        .find('.error-msg-text')
        .attr('hidden', true);
      const thisPhone = $(this);
      const curval = $(this).val();
      thisPhone.val(mfaOktaAccSettings.formatSmsPhoneNumber(curval));
    } else {
      return false;
    }
    return null;
  },

  onInputVerificationNumber(e) {
    const targetEle = $(e.target);
    if (targetEle.val() !== '') {
      targetEle.removeClass('error-msg-textbox');
      targetEle
        .next()
        .find('.error-msg-text')
        .attr('hidden', true);
    }
  },

  validatePhoneNumber(e) {
    const targetEle = $(e.target);
    const targetEleContainer = targetEle.closest(
      mfaAccSettingsClosestParentEle
    );
    const targetEleValue = targetEleContainer.find(mfaAccSettingsPhoneNumber);

    let patternMismatchEle = targetEle
      .parents(mfaAccSettingsPhoneSection)
      .find(mfaEnrollInvalidPhoneError);
    targetEle.removeClass('error-msg-textbox');
    if (e.target.validity.valueMissing || targetEleValue.val().length < 12) {
      e.preventDefault();
      patternMismatchEle.attr('hidden', false);
      targetEleValue.addClass('error-msg-textbox');
      return false;
    } else {
      targetEle.removeClass('error-msg-textbox');
      targetEle
        .parents(mfaAccSettingsPhoneSection)
        .find('.error-msg-text')
        .attr('hidden', true);
      return true;
    }
  },

  startOtpExpiryTimer(buttonEvent) {
    const targetParentEle = buttonEvent.closest(mfaAccSettingsClosestParentEle);
    let otpExpiryTimeDuration = 0;
    let downloadTimer = setInterval(function() {
      if (otpExpiryTimeDuration >= mfaEnrollOtpTimer) {
        clearInterval(downloadTimer);
        targetParentEle.find(mfaAccSettingsOtpResendEle).removeClass('hidden');
        targetParentEle.find(mfaAccSettingsOtpMsg).addClass('invisible');
      }
      targetParentEle
        .find(mfaAccSettingsOtpEle)
        .text(mfaEnrollOtpTimer - otpExpiryTimeDuration);
      otpExpiryTimeDuration += 1;
    }, 1000);
  },

  onInputOtpNumber(e) {
    const targetEle = $(e.target);
    targetEle.removeClass('error-msg-textbox');
    targetEle.next().attr('hidden', true);
  },

  onClickDisplayMfaType(e) {
    e.preventDefault();
    const targetEle = $(e.target);
    const targetParentEle = targetEle.closest(mfaAccSettingsClosestParentEle);
    if (targetEle.attr('data-type-id') === mfaEnrollSetupTypeSms) {
      targetParentEle
        .next()
        .find(mfaAccSettingsSetupEle)
        .prop('disabled', true);
    } else {
      targetParentEle
        .prev()
        .find(mfaAccSettingsSetupEle)
        .prop('disabled', true);
    }
    if (targetEle.attr('data-id') === mfaAccSettingsSetupText) {
      targetParentEle.find(mfaAccSettingsSetupRow).addClass('hidden');
      targetParentEle
        .find(mfaAccSettingsSetupTypeSelected)
        .removeClass('hidden');
      targetParentEle
        .find(mfaAccSettingsPhoneNumber)
        .val('')
        .focus();
    } else {
      $.colorbox({
        href: '#openRemoveMfaModal',
        open: true,
        inline: true,
        onLoad: $(cboxOverlay).css('position', 'fixed'),
        onComplete: function() {
          const pwdEle = $(mfaAccSettingsRemovePwdEle);
          pwdEle.val('');
          $(`${mfaAccSettingsRemoveForm} .showhide-field`).addClass('hide');
          mfaOktaAccSettings.onLoadModalDefault(pwdEle);
          const removeModalAuthType = $(mfaAccSettingsRemoveAuthType);
          if (targetEle.attr('data-type-id') === mfaEnrollSetupTypeSms) {
            removeModalAuthType.text(mfaAccSettingsRemoveSmsSetup);
            $(mfaAccSettingsEnrollType).val(mfaEnrollSetupTypeSms);
          } else {
            removeModalAuthType.text(mfaAccSettingsRemoveVoiceSetup);
            $(mfaAccSettingsEnrollType).val(mfaEnrollSetupTypeCall);
          }
        },
        width: checkWidth(),
        height: mfaOktaAccSettings.checkHeight(),
        className: 'mfa-modal',
        onClosed: function close() {
          $(mfaAccSettingsContainer)
            .find(mfaAccSettingsSetupEle)
            .prop('disabled', false);
          targetEle.focus();
        }
      });
    }
  },

  onClickCancelSetup(e) {
    const targetEle = $(e.target);
    const targetParentEle = targetEle.closest(mfaAccSettingsClosestParentEle);
    targetParentEle.find(mfaAccSettingsSetupRow).removeClass('hidden');
    targetParentEle.find(mfaAccSettingsSetupTypeSelected).addClass('hidden');
    targetParentEle.find(mfaAccSettingsVerifySection).addClass('hidden');
    targetParentEle.find(mfaAccSettingsErrorAlerts).attr('hidden', 'true');
    targetParentEle
      .find(mfaAccSettingsPhoneNumber)
      .removeClass(mfaAccSettingsErrorInputBox);
    targetParentEle
      .parents(mfaAccSettingsContainer)
      .find(mfaAccSettingsSetupEle)
      .prop('disabled', false);
  },

  updateFactorIdAttr(targetElement, factorId) {
    if (targetElement.attr('data-type-id') === mfaEnrollSetupTypeSms) {
      $(mfaAccSettingsSmsContainer)
        .find(`[id='mfa-remove-setup-${mfaEnrollSetupTypeSms}']`)
        .attr('data-factor-id', factorId);
    } else {
      $(mfaAccSettingsVoiceContainer)
        .find(`[id='mfa-remove-setup-${mfaEnrollSetupTypeCall}']`)
        .attr('data-factor-id', factorId);
    }
  },

  onClickSendOtp(e) {
    const targetEle = $(e.target);
    const targetParentEle = targetEle.closest(mfaAccSettingsClosestParentEle);
    const targetEleInput = targetParentEle.find(mfaAccSettingsPhoneNumber);
    const mfaAccSettingsDefaultCountryCode = $('#countryPhoneCode').val();
    if (mfaOktaAccSettings.validatePhoneNumber(e)) {
      targetEleInput
        .removeClass('error-msg-textbox')
        .next()
        .attr('hidden', true);
      // ajax code to send otp and otp timer
      const phoneNumberDotRemove = targetEleInput
        .val()
        .split('.')
        .join('');
      const phoneNumberCtyCode =
        mfaAccSettingsDefaultCountryCode + ' ' + phoneNumberDotRemove;
      const objParam = {
        factorType: targetEle.attr('data-type-id'),
        phoneNumber: phoneNumberCtyCode
      };
      const requestURL = `${ACC.config.encodedContextPath}${API_REFERENCE.mfa.addFactor}`;
      const submitdata = JSON.stringify(objParam);
      if (!mfaAccSettingsSendOtpAjaxReq) return false;
      mfaAccSettingsSendOtpAjaxReq = false;
      jsonPost(requestURL, submitdata)
        .then(response => {
          mfaAccSettingsSendOtpAjaxReq = true;
          if (response.status === mfaEnrollSendCodePass) {
            mfaOktaAccSettings.updateFactorIdAttr(targetEle, response.id);
            targetParentEle
              .find(mfaAccSettingsSetupTypeSelected)
              .addClass('hidden');
            targetParentEle
              .find(mfaAccSettingsVerifySection)
              .removeClass('hidden');
            const targetElePhone = targetParentEle.find(
              `${mfaAccSettingsVerifySection} ${mfaAccSettingsVerifyInputEle}`
            );
            targetParentEle.find(mfaAccSettingsOtpResendEle).addClass('hidden');
            targetElePhone
              .val('')
              .focus()
              .removeClass('error-msg-textbox');
            targetElePhone.next().attr('hidden', true);
            mfaOktaAccSettings.startOtpExpiryTimer(targetEle);
          } else if (response.status === mfaEnrollSuccessCheck) {
            mfaOktaAccSettings.updateFactorIdAttr(targetEle, response.id);
            mfaOktaAccSettings.updateSetupButton(targetEle);
            mfaOktaAccSettings.onClickCancelSetup(e);
            $(mfaAccSettingsSetupSuccess).removeClass('hidden');
          }
        })
        .catch(error => {
          mfaAccSettingsSendOtpAjaxReq = true;
        });
    }
  },

  onClickResendOtp(e) {
    const targetEle = $(e.target);
    const targetParentEle = targetEle.closest(mfaAccSettingsClosestParentEle);
    const targetEleInput = targetParentEle.find(mfaAccSettingsPhoneNumber);
    const mfaAccSettingsDefaultCountryCode = $('#countryPhoneCode').val();
    const phoneNumberDotRemove = targetEleInput
      .val()
      .split('.')
      .join('');
    const phoneNumberCtyCode =
      mfaAccSettingsDefaultCountryCode + ' ' + phoneNumberDotRemove;
    const objParam = {
      factorType: targetEle.attr('data-type-id'),
      phoneNumber: phoneNumberCtyCode
    };
    const requestURL = `${ACC.config.encodedContextPath}${API_REFERENCE.mfa.addFactor}`;
    const submitdata = JSON.stringify(objParam);
    if (!mfaAccSettingsReSendOtpAjaxReq) return false;
    mfaAccSettingsReSendOtpAjaxReq = false;
    jsonPost(requestURL, submitdata)
      .then(response => {
        mfaAccSettingsReSendOtpAjaxReq = true;
      })
      .catch(error => {
        mfaAccSettingsReSendOtpAjaxReq = true;
      });
    targetParentEle.find(mfaAccSettingsOtpMsg).removeClass('invisible');
    mfaOktaAccSettings.startOtpExpiryTimer(targetEle);
  },

  onClickVerifyOtp(e) {
    const targetEle = $(e.target);
    const targetParentEle = targetEle.closest(mfaAccSettingsClosestParentEle);
    const targetEleInput = targetParentEle.find(mfaAccSettingsVerifyInputEle);
    if (targetEleInput.val() !== '') {
      targetParentEle.find(mfaAccSettingsErrorAlerts).attr('hidden', true);
      targetEleInput.removeClass('error-msg-textbox');
      const objParam = {
        passCode: targetEleInput.val(),
        factorType: targetEle.attr('data-type-id')
      };
      const requestURL = `${ACC.config.encodedContextPath}${API_REFERENCE.mfa.activateFactor}`;
      const submitdata = JSON.stringify(objParam);
      if (!mfaAccSettingsVerifyOtpAjaxReq) return false;
      mfaAccSettingsVerifyOtpAjaxReq = false;
      jsonPost(requestURL, submitdata)
        .then(response => {
          mfaAccSettingsVerifyOtpAjaxReq = true;
          if (response.status === mfaEnrollSuccessCheck) {
            mfaOktaAccSettings.updateSetupButton(targetEle);
            mfaOktaAccSettings.onClickCancelSetup(e);
            $(mfaAccSettingsSetupSuccess).removeClass('hidden');
          } else {
            targetParentEle
              .find(mfaAccSettingsErrorAlerts)
              .attr('hidden', true);
            targetParentEle
              .find(mfaAccSettingsErrorOtpMismatch)
              .attr('hidden', false);
            targetEleInput.addClass('error-msg-textbox').focus();
          }
        })
        .catch(error => {
          mfaAccSettingsVerifyOtpAjaxReq = true;
        });
    } else {
      targetParentEle.find(mfaAccSettingsErrorAlerts).attr('hidden', true);
      targetEleInput.next().attr('hidden', false);
      targetEleInput.addClass('error-msg-textbox');
    }
  },

  updateSetupButton(buttonEle) {
    if (buttonEle.attr('data-type-id') === mfaEnrollSetupTypeSms) {
      $(mfaAccSettingsSmsContainer)
        .find(mfaAccSettingsSetupSection)
        .addClass('hidden');
      $(mfaAccSettingsSmsContainer)
        .find(`[id='mfa-remove-setup-${mfaEnrollSetupTypeSms}']`)
        .parent()
        .removeClass('hidden');
    } else {
      $(mfaAccSettingsVoiceContainer)
        .find(mfaAccSettingsSetupSection)
        .addClass('hidden');
      $(mfaAccSettingsVoiceContainer)
        .find(`[id='mfa-remove-setup-${mfaEnrollSetupTypeCall}']`)
        .parent()
        .removeClass('hidden');
    }
  },

  onLoadModalDefault(targetElement) {
    targetElement.next().addClass('hidden');
    targetElement.removeClass('error-msg-textbox');
  },

  onInputPasswordValue(e) {
    const targetEle = $(e.target);
    const targetInputEle = $(`${mfaAccSettingsRemoveForm} .showhide-field`);
    mfaOktaAccSettings.onLoadModalDefault(targetEle);
    if (targetEle.val().length > 0) {
      targetInputEle.removeClass('hide');
    } else {
      targetInputEle.addClass('hide');
    }
  },

  updateRemoveButtonText() {
    if ($(mfaAccSettingsEnrollType).val() === mfaEnrollSetupTypeSms) {
      $(mfaAccSettingsSmsContainer)
        .find(mfaAccSettingsSetupSection)
        .addClass('hidden');
      $(mfaAccSettingsSmsContainer)
        .find(`[id='mfa-account-setup-${mfaEnrollSetupTypeSms}']`)
        .parent()
        .removeClass('hidden');
    } else {
      $(mfaAccSettingsVoiceContainer)
        .find(mfaAccSettingsSetupSection)
        .addClass('hidden');
      $(mfaAccSettingsVoiceContainer)
        .find(`[id='mfa-account-setup-${mfaEnrollSetupTypeCall}']`)
        .parent()
        .removeClass('hidden');
    }
  },

  onClickCloseRemoveMfaModal() {
    $.colorbox.close();
  },

  onClickConfirmPwd(e) {
    const inputEle = $(mfaAccSettingsRemovePwdEle);
    if (inputEle.val() !== '') {
      const requestURL =
        ACC.config.encodedContextPath + '/my-account-home/validate';
      const passFormData = $(
        `${mfaAccSettingsRemoveForm} ${mfaAccSettingsRemovePwdEle}`
      ).serialize();
      if (!mfaAccSettingsRemoveFactorAjaxReq) return false;
      mfaAccSettingsRemoveFactorAjaxReq = false;
      formPost(requestURL, passFormData)
        .then(response => {
          const jsonResponse = JSON.parse(response);
          $(mfaAccSettingsAlerts).addClass('hidden');
          mfaOktaAccSettings.onClickCloseRemoveMfaModal();
          if (jsonResponse.Error === 'FAIL') {
            mfaAccSettingsRemoveFactorAjaxReq = true;
            $(mfaAccSettingsFailureSetup).removeClass('hidden');
          } else {
            let factorIdValue;
            if ($(mfaAccSettingsEnrollType).val() === mfaEnrollSetupTypeSms) {
              factorIdValue = $(mfaAccSettingsSmsContainer)
                .find(`[id='mfa-remove-setup-${mfaEnrollSetupTypeSms}']`)
                .attr('data-factor-id');
            } else {
              factorIdValue = $(mfaAccSettingsVoiceContainer)
                .find(`[id='mfa-remove-setup-${mfaEnrollSetupTypeCall}']`)
                .attr('data-factor-id');
            }
            const objParam = {
              factorId: factorIdValue,
              factorType: $(mfaAccSettingsEnrollType).val()
            };
            const requestURL = `${ACC.config.encodedContextPath}${API_REFERENCE.mfa.removeFactor}`;
            const submitdata = JSON.stringify(objParam);
            jsonPost(requestURL, submitdata).then(response => {
              mfaAccSettingsRemoveFactorAjaxReq = true;
              if (response === '200 OK' || response === '200') {
                mfaOktaAccSettings.updateRemoveButtonText();
                $(mfaAccSettingsSetupSuccess).removeClass('hidden');
              } else {
                $(mfaAccSettingsFailureSetup).removeClass('hidden');
              }
            });
          }
        })
        .catch(error => {
          mfaAccSettingsRemoveFactorAjaxReq = true;
        });
    } else {
      inputEle.next().removeClass('hidden');
      inputEle.addClass('error-msg-textbox');
    }
  },

  onClickCloseDisplayMessage(e) {
    $(e.target)
      .closest('.mfa-setup-alert')
      .addClass('hidden');
  },

  init() {
    $(document).on(
      'keypress',
      mfaAccSettingsPhoneNumber,
      this.onInputPhoneNumber
    );
    $(document).on(
      'keypress',
      mfaAccSettingsVerifyInputEle,
      this.onInputVerificationNumber
    );
    $(document).on('click', mfaAccSettingsSetupEle, this.onClickDisplayMfaType);
    $(document).on(
      'click',
      mfaAccSettingsSetupCancelBtn,
      this.onClickCancelSetup
    );
    $(document).on('click', mfaAccSettingsSendOtpButton, this.onClickSendOtp);
    $(document).on(
      'click',
      mfaAccSettingsOtpResendBtnEle,
      this.onClickResendOtp
    );
    $(document).on('click', mfaAccSettingsVerifyBtnEle, this.onClickVerifyOtp);
    $(document).on(
      'input',
      mfaAccSettingsRemovePwdEle,
      this.onInputPasswordValue
    );
    $(document).on(
      'keypress click',
      `${mfaAccSettingsRemoveCancelBtn},${mfaAccSettingsRemoveCloseBtn}`,
      this.onClickCloseRemoveMfaModal
    );
    $(document).on(
      'click',
      `#${mfaAccSettingsRemoveConfirmBtn}`,
      this.onClickConfirmPwd
    );
    $(document).on(
      'click',
      '.mfa-setup-alert .close',
      this.onClickCloseDisplayMessage
    );
  }
};
mfaOktaAccSettings.init();
export default mfaOktaAccSettings;
